export default __webpack_public_path__ + "images/de4c928f1a980341e6f0edd9f52aba70-world_music.webp";